import { PurchaseFormValues } from '../../../types/purchases/BasePurchase';
import { PurchaseFinalizeDTO } from './types';

export const mapCreditNotePurchase = (form: PurchaseFormValues): PurchaseFinalizeDTO => {
  return {
    comments: form.comments?.trim() || '',
    paymentCondition: null,
    paymentMethod: null,
    individualPayments: null,
  };
};
